import { useEffect } from 'react'
import { MenuItem } from './MenuItem'
import { MenuTree } from './MenuTree'
import { useSistema } from '../../../hooks/useSistema'

function renderItem(menu, index) {
    //Busca sub-menus que não sejam ações
    const sub = menu.submenu?.filter((m => m.acao !== "1")&&(m => m.acao !== 1))
    
    // if ((menu.submenu) && (menu.submenu.length > 0)) {
    if (sub?.length > 0) {
        //Declara árvore
        return (
            <MenuTree key={index} menu={menu}>
                {sub.map((item, index) => { return renderItem(item, index) })}
            </MenuTree>
        )
    } else {
        //Declara item
        return <MenuItem key={index} menu={menu} />
    }
}

export function Menu(props){
    const { menu } = useSistema()

    useEffect(() => {
        //Resolve problema do menu não carregar
        const trees = window.$('[data-widget="treeview"]');
        trees.Treeview('init');
    }, [])
    
    return (
        <nav className="mt-2">
            <ul className="nav nav-pills nav-sidebar flex-column text-sm nav-legacy nav-compact nav-child-indent"
                data-widget="treeview" role="menu" data-accordion="false" id="menuApp">
                {menu.map((item, index) => {
                    return renderItem(item, index);
                })}
            </ul>
        </nav>
    )
}